import React from 'react';
import { QrCode } from 'lucide-react';

const QRCard = ({ qr }) => {
  if (!qr) return null;

  return (
    <div className="mx-auto mt-6 max-w-xs rounded-2xl bg-white p-6 shadow-xl transition hover:shadow-2xl">
      <div className="text-center">
        <QrCode size={40} className="mx-auto mb-2 text-[#075e54]" />
        <h2 className="text-lg font-bold text-slate-800">Scan with WhatsApp</h2>
      </div>
      <div className="mt-4 border-2 border-dashed border-green-500 rounded-xl p-2">
        <img
          src={qr}
          alt="QR Code"
          className="w-full rounded-lg"
        />
      </div>
      <p className="mt-4 text-sm text-slate-500 text-center leading-relaxed">
        Open WhatsApp on your phone →{' '}
        <strong className="text-slate-700">Linked Devices</strong> →{' '}
        <strong className="text-slate-700">Link a Device</strong>
      </p>
    </div>
  );
};

export default QRCard;